import React, { useState, useRef, KeyboardEvent } from "react";
import allImgPaths from "assets/images";

interface PatentChipsInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const PatentChipsInput: React.FC<PatentChipsInputProps> = ({
  value,
  onChange,
  placeholder = "Enter patent numbers",
}) => {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  // const patents = value.split(",").filter((patent) => patent.trim() !== "");
  const patents = value.split(";").filter((patent) => patent.trim() !== "");

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    // if ((e.key === "Tab" || e.key === ",") && inputValue.trim()) {
    if ((e.key === "Tab" || e.key === ";") && inputValue.trim()) {
      e.preventDefault();
      addPatent(inputValue.trim());
    } else if (e.key === "Backspace" && !inputValue && patents.length > 0) {
      e.preventDefault();
      removePatent(patents.length - 1);
    }
  };

  const addPatent = (patent: string) => {
    const newPatents = [...patents, patent];
    onChange(newPatents.join(";"));
    setInputValue("");
  };

  const removePatent = (indexToRemove: number) => {
    const newPatents = patents.filter((_, index) => index !== indexToRemove);
    onChange(newPatents.join(";"));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleBlur = () => {
    if (inputValue.trim()) {
      addPatent(inputValue.trim());
    }
  };

  return (
    <div className="flex flex-wrap gap-2 p-2 bg-white border border-[#E6E6E6] rounded-lg min-h-[44px]">
      {patents.map((patent, index) => (
        <div
          key={index}
          className="flex items-center gap-1 px-2 py-1 bg-[#F2F4F7] rounded-md text-sm"
        >
          <span>{patent}</span>
          <button
            type="button"
            onClick={() => removePatent(index)}
            className="flex items-center justify-center w-4 h-4 text-gray-500 hover:text-gray-700"
          >
            <img src={allImgPaths.closeIcon} alt="remove" className="w-3 h-3" />
          </button>
        </div>
      ))}
      <input
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        placeholder={patents.length === 0 ? placeholder : ""}
        className="flex-1 min-w-[120px] outline-none bg-transparent"
      />
    </div>
  );
};

export default PatentChipsInput;
